import { useTranslation } from 'react-i18next';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { InstructionCreationFormWrapper } from 'src/Components/Forms/Instruction/InstructionCreationFormWrapper';
import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';

const CreateInstructionDrawer = () => {
  const { t } = useTranslation();

  const assetId = useCurrentAssetId();

  return (
    <AnimatedRoutedDrawer
      title={t('instructions.createInstruction', 'Ajouter une consigne')}
      to={`/asset/${assetId}/guides/instructions`}
    >
      {({ onClose }) => <InstructionCreationFormWrapper onCreate={onClose} onCancel={onClose} />}
    </AnimatedRoutedDrawer>
  );
};

export default CreateInstructionDrawer;
